import { openBrowserPopup } from 'Helpers/browserPopup'
import useMessageThumbnail from 'Hooks/useMessageThumbnail'
import { sessionId } from 'mailup-react-helpers'

import {
  Spinner,
  Thumb,
  ThumbContainer,
  ThumbDefaultOverlay
} from 'mailup-web-components'

const BoxThumbnail = ({ item }) => {
  const [url, status] = useMessageThumbnail({
    id: item.IdMessaggio,
    hasThumbnail: item.HasThumbnail,
    updateDate: item.LastUpdated
  })

  const openEmailPreview = id => {
    openBrowserPopup(
      `/${sessionId}/messages/email/${id}/preview?sourceCode=listemail&idTriggered=0`
    )
  }
  const Overlay = () => {
    return <ThumbDefaultOverlay />
  }

  return (
    <>
      <ThumbContainer>
        <Thumb
          aspectRatio={90 / 110}
          data-mu-test={`thumbnail-messages-${item.IdMessaggio}`}
          HoverComponent={Overlay}
          hoverComponentProps={{ id: item.IdMessaggio }}
          onClick={() => openEmailPreview(item.IdMessaggio)}
        >
          {status === 'loading' && <Spinner />}
          {status !== 'loading' && <img src={url} />}
        </Thumb>
      </ThumbContainer>
    </>
  )
}

export default BoxThumbnail
